import { render, staticRenderFns } from "./KPIReport.vue?vue&type=template&id=bb22d23a"
import script from "./KPIReport.vue?vue&type=script&lang=js"
export * from "./KPIReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports